<template>
  <div class="vw100 vh100 flex-box flex-col al-c ju-c">
    <div class="w100">
      <div class="w120 mc flex-box al-c">
        <div class="flex-1" style="height: 74px">
          <img
            class="logo"
            v-show="getConfig.logo"
            :src="`${baseUrl}images/${getConfig.logo}`"
          />
        </div>
      </div>
    </div>
    <div
      class="w100 mt10 login-wrapper flex-box ju-c"
      :style="{ 'background-image': `url(${baseUrl}images/login-bg.png)` }"
    >
      <div
        class="flex-box al-c login-main"
        :style="{
          'background-image': `url(${baseUrl}images/login-main-bg.png)`,
        }"
      >
        <div class="flex-1 pl20 pr20 ml20">
          <img :src="`${baseUrl}images/login-title1.png`" />
        </div>
        <div class="login-view">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
          >
            <p class="pb10 tx-c" style="color: #666666; font-size: 26px">
              办事大厅
            </p>
            <el-form-item label="" prop="username">
              <el-input
                style="width: 100%"
                size="large"
                @input="userChange"
                class="verify-input fl"
                v-model="ruleForm.username"
                clearable
                placeholder="请输入手机号"
              >
                <div
                  slot="prefix"
                  style="height: 40px; width: 40px; background-color: #218dee"
                >
                  <i class="el-icon-phone"></i>
                </div>
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="code">
              <div class="w100 mt20 cl-f">
                <el-input
                  size="large"
                  class="verify-input fl"
                  v-model="ruleForm.code"
                  placeholder="请输入验证码"
                >
                  <div
                    slot="prefix"
                    style="height: 40px; width: 40px; background-color: #218dee"
                  >
                    <i class="el-icon-discount"></i>
                  </div>
                </el-input>
                <el-button
                  type="primary"
                  class="get_code_btn fl"
                  style="width: 113px"
                  :disabled="usernameBlo"
                  @click="sendPwdCodeHandle"
                  v-if="!isCodeing"
                  >获取验证码</el-button
                >
                <div class="get_code_btn timer fl" v-if="isCodeing">
                  <span>{{ count }}s</span> 后重新获取
                </div>
              </div>
            </el-form-item>
            <!--<el-form-item label="" prop="password">-->
            <!--<div class="w100 mt20 pl5 pr5">-->
            <!--<el-input size="large" class="password-input" auto-complete="new-password" type="password" v-model="ruleForm.password" @keyup.enter.native="handleSubmit" clearable show-password placeholder="请输入密码">-->
            <!--<div slot="prefix" style="height:40px;width:40px;background-color:#218DEE">-->
            <!--<i class="el-icon-lock"></i>-->
            <!--</div>-->
            <!--</el-input>-->
            <!--</div>-->
            <!--</el-form-item>-->
            <div class="w100 mt20 pl5 pr5 flex-box">
              <div class="flex-1"></div>
              <router-link class="cu-p" :to="'/login'" style="color: #9a9898"
                >去登录</router-link
              >
            </div>
            <div class="w100 mt20 pb20 pl5 pr5">
              <el-button
                class="w100"
                size="large"
                type="primary"
                :disabled="!ruleForm.code || !ruleForm.username"
                @click="submitForm"
                >提 交</el-button
              >
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <!--<div class="w100 tx-c grey font-14" style="line-height:40px">技术支持：南宁市迈越软件有限公司</div>-->
  </div>
</template>

<script>
import {
  resetPwdByCode,
  sendPwdCode,
  sendPhoneCode,
  saveLogin,
  getLoginConfig,
} from "@/api/login";
import AddRouterFunc from "@/router/addRouter";
import { mapGetters, mapActions } from "vuex";
import { goHomeAfterLogin } from "@/util/utils";
export default {
  name: "phoneLogin",
  components: {},
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      getConfig: {},
      isCodeing: false,
      count: 0,
      loading: false,
      requesting: false,
      usernameBlo: true,
      ruleForm: {
        username: "",
        code: "",
      },
      rules: {
        username: [
          { message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/,
            message: "请输入正确的手机号",
          },
        ],
      },
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getLoginConfig();
  },

  methods: {
    ...mapActions([
      "setUserToken",
      "setUserData",
      "logout",
      "setAccessToken",
      "bpmnSecurityLoginHandle",
    ]),
    userChange(val) {
      this.$refs["ruleForm"].validateField("username", emailError => {
        if (!emailError) {
          this.usernameBlo = false;
        } else {
          this.usernameBlo = true;
          return false;
        }
      });
    },
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params = {
            username:
              "SMS@" + this.ruleForm.username + "-" + this.ruleForm.code,
          };
          saveLogin(params)
            .then(res => {
              if ("access_token" in res.data) {
                // await this.bpmLogin(res.data.username)
                // window.sessionStorage.setItem(
                //     "nz_access_token",
                //     "Bearer " + res.data.access_token
                // );
                this.$store.commit("SET_ACCESS_TOKEN", res.data.access_token);
                setTimeout(() => {
                  // this.$store.commit("SET_ACCESS_TOKEN", res.data.access_token)
                  // 获取组织部门树
                  this.$store
                    .dispatch("getDeptTree")
                    .then(() => {})
                    .catch(err => {
                      console.log(err);
                    });
                  this.bpmnSecurityLoginHandle({
                    userName: res.data.username,
                    deviceType: "pc",
                  }).catch(() => {
                    // this.$store.commit("SET_ACCESS_TOKEN", null);
                    // sessionStorage.removeItem('nz_access_token')
                  });
                  //获取用户权限
                  this.$store
                    .dispatch("GetUserPermissions")
                    .then(res => {
                      //获取个人菜单;
                      let userInfo = {
                        deviceType: "pc",
                        userId: res.data.sysUser.userId,
                        userImg: res.data.sysUser.avatar,
                        userName: res.data.sysUser.username,
                        deptId: res.data.sysUser.deptId,
                        roleCodes: res.data.roleCodes,
                        firstLogin: (res.data.sysUser && res.data.sysUser.firstLogin) || "",
                      };
                      let routerData = res.data.permissions;
                      routerData = [
                        ...routerData,
                        "/office",
                        "/test",
                        "/statistical/all",
                        "/ServeCenterDetail",
                        "/notifyDetail",
                        "/serveEvaluate",
                        "/search",
                        "/noticesAndFilesPagination",
                        "/fileDetail",
                        "/teacherTimetable",
                        "/classRoomTimetable",
                        "/MySchedule",
                        "/classTimetable",
                        "/staff",
                        "/jobshire",
                        "/annualappraisal",
                        "/wage",
                        "/classroomQuery",
                        "/grade",
                        "/teachingInquiry",
                        "/evaluation",
                      ];
                      let newArr = JSON.parse(JSON.stringify(routerData));
                      if ((res.data.roleCodes || []).includes("ROLE_ADMIN")) {
                        //   routerData = [];
                        //   const routeHandler = function (arr) {

                        //   for(let i=0;i<arr.length;i++){
                        //     routerData.push(arr[i].path)
                        //     if(arr[i].children){
                        //       routeHandler(arr[i].children)
                        //     }
                        //   }
                        // }
                        //     routeHandler(newArr)
                        newArr = newArr.concat([
                          "system-management",
                          "business-management",
                          "advices-management",
                          "efficiency-management",
                          "data-management",
                        ]);
                      }
                      routerData = [...newArr];
                      this.setUserData({
                        ...userInfo,
                        routerData,
                      });

                      localStorage.setItem(
                        "userData",
                        JSON.stringify({
                          ...userInfo,
                          routerData,
                        })
                      );

                      sessionStorage.setItem("loginFrom", "system");

                      this.logining = false;

                      const routers = AddRouterFunc.getNewRouerData(routerData);
                      this.$router.addRoutes(routers);

                      goHomeAfterLogin(this, userInfo.firstLogin);
                    })
                    .catch(err => {
                      console.log(err);
                    });
                }, 1000);
              } else {
                this.logining = false;
              }
            })
            .catch(err => {
              this.$message.error("登录出错");
              this.ruleForm.username = "";
              this.ruleForm.code = "";
              this.logining = false;
            });
        }
      });
    },

    sendPwdCodeHandle() {
      sendPhoneCode(this.ruleForm.username)
        .then(({ data }) => {
          if (data.code == 0) {
            this.getVerifyCode();
          } else {
            this.$message.warning(data.msg || "短信发送失败!");
          }
        })
        .catch(err => {});
    },

    getVerifyCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.isCodeing = true;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.isCodeing = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async getLoginConfig() {
      let res = await getLoginConfig();
      res.data.data.isOpenCassso == "1"
        ? (res.data.data.isOpenCassso = true)
        : (res.data.data.isOpenCassso = false);
      res.data.data.middlePage == "1"
        ? (res.data.data.middlePage = true)
        : (res.data.data.middlePage = false);
      res.data.data.phone == "1"
        ? (res.data.data.phone = true)
        : (res.data.data.phone = false);
      res.data.data.mobileOrPc == "1"
        ? (res.data.data.mobileOrPc = true)
        : (res.data.data.mobileOrPc = false);
      this.phoneBlo = res.data.data.phone;
      this.getConfig = res.data.data;
      window.sessionStorage.setItem(
        "setConfig",
        JSON.stringify(this.getConfig)
      );
      let faviconLink = document.querySelector("#faviconLink");
      if (faviconLink) {
        faviconLink.setAttribute("href", this.getConfig.favicon);
      }
    },
  },
  destroyed() {},

  filters: {},
};
</script>

<style scoped lang="less">
/deep/div.el-form-item {
  margin-bottom: 0px !important;
}
/deep/div.el-form-item__content {
  margin-left: 0px !important;
}
.login-wrapper {
  height: 680px;
  background: #368ae2 center bottom no-repeat;
}

.login-main {
  margin-top: 60px;
  width: 900px;
  height: 430px;
  background: #fff right bottom no-repeat;
  box-shadow: 0 0 12px 10px #327cca;
}

.login-view {
  margin-right: 40px;
  width: 350px;
  padding: 20px 0 0 40px;
  border-left: 1px solid #ddd;
}
.username-input,
.verify-input,
.password-input {
  line-height: 40px;
  /deep/ .el-input__inner:not(.code-input) {
    border-radius: 0;
    text-indent: 20px;
    background-color: #f2f4f4;
  }
  /deep/ .el-input__prefix {
    left: 0;
    color: #fff;
    font-size: 18px;
  }
}
.verify-input {
  width: 185px;
}
.code-img {
  height: 40px;
  width: 140px;
  cursor: pointer;
}
.logo {
  height: 60px;
  margin-top: 10px;
}
.get_code_btn {
  width: 50px;
  width: 101px;
  margin-left: 10px;
  height: 40px;
  border-radius: 0px;
  &.timer {
    color: #595b5d;
    background: #f2f4f4;
    line-height: 40px;
    text-align: center;
    font-size: 12px;
    > span {
      color: #2ba246;
      font-weight: bold;
    }
  }
}
</style>
